/**
 * Application roles. Global (not tenant-scoped) per the schema contract:
 * the `role` table is global and `user_role` binds a user to a role within a tenant.
 */
export var Role;
(function (Role) {
    Role["Admin"] = "admin";
    Role["Manager"] = "manager";
    Role["Employee"] = "employee";
})(Role || (Role = {}));
/** Every role value, in descending privilege order. Frozen to prevent mutation. */
export const ALL_ROLES = Object.freeze([Role.Admin, Role.Manager, Role.Employee]);
const ROLE_VALUES = new Set(ALL_ROLES);
/** Runtime type guard: true when `x` is one of the known {@link Role} values. */
export function isRole(x) {
    return typeof x === 'string' && ROLE_VALUES.has(x);
}
//# sourceMappingURL=roles.js.map